import Layout from '@/layout'

const route = {
  path: '/merchantMaintenanceNumber',
  component: Layout,
  // redirect: '/customer/publicPlan/index',
  alwaysShow: true, // will always show the root menu
  name: 'merchantMaintenanceNumber',
  meta: {
    title: '商户养号',
    icon: 'MMN',
    roles: [
      'merchant.maintenance.number'
    ]
  },
  children: [
    {
      path: '/denterpriselinks/denterpriselinksing/index',
      component: () => import('@/views/denterpriselinksing/index.vue'),
      name: 'BackConfig',
      meta: {
        title: '企业微信',
        icon: 'component',
        roles: [
          'wechat_company.index'
        ]
      }
    },
    {
      path: '/merchantpay/merchantpaying/index',
      component: () => import('@/views/merchantpaying/index.vue'),
      name: 'BackConfig',
      meta: {
        title: '商户号支付',
        icon: 'component',
        roles: [
          'pay_code.index'
        ]
      }
    }
  ]
}

export default route
